module.exports = __webpack_public_path__ + "img/Bear13.3cc1bbd5.jpg";